import React from "react";
import { Redirect } from "react-router";
import { PageHeader } from "../../components/layout/header/Header";
import { StandardPageWrapper } from "../../components/layout/StandardPageWrapper";
import { usePrimaryOrganization, usePrimaryOrganizationId } from "../../hooks";
import { useSelfOrganizationUser } from "../../hooks/useOrganization";
import { RouteHelpers } from "../../root/routes";
import { McpAccessCard } from "./McpAccessCard";
import { SettingsTabs, isMcpEnabled } from "./SettingsTabs";

/**
 * Settings that belong to the signed-in user rather than the organization, and that most people
 * never need. Today that is just MCP access tokens.
 */
export const AdvancedSettings = () => {
  const organizationId = usePrimaryOrganizationId();
  const [organization] = usePrimaryOrganization();
  const currentOrgUser = useSelfOrganizationUser();
  const mcpEnabled = isMcpEnabled(organization, currentOrgUser);

  // Wait for the org-user row before treating a missing membership as "not enabled"; otherwise a
  // direct member would bounce to settings while users are still loading.
  if (organization && !mcpEnabled && (organization.featureMcp !== true || currentOrgUser)) {
    return <Redirect to={RouteHelpers.organization.settings(organizationId)} />;
  }

  return (
    <StandardPageWrapper>
      <div className="max-width-896">
        <PageHeader titleContent="Account Settings" />
        <SettingsTabs current="advanced" />
        {mcpEnabled && <McpAccessCard organizationId={organizationId} />}
      </div>
    </StandardPageWrapper>
  );
};
